export default __webpack_public_path__ + "static/media/Dungeonloot300x300.1f227572.png";